import { ServiceType } from '@/shared/api/protocol-ts/api/billing_new/dto_services_new_pb';

export const ORDER_REPORT_SERVICE_TYPES = [
  ServiceType.ServiceType_Order_CBCT_GP_Analysis,
  ServiceType.ServiceType_Order_Panoramic_GP_Analysis,
  ServiceType.ServiceType_Order_IOXRay_GP_Analysis,
  ServiceType.ServiceType_Order_CBCT_STL_Analysis,
  ServiceType.ServiceType_Order_CBCT_IOS_Superimposition_Analysis,
  ServiceType.ServiceType_Order_ImplantStudio_Analysis,
  ServiceType.ServiceType_Order_OrthoStudio_Analysis,
  ServiceType.ServiceType_Order_CBCT_Orthodontic_Analysis,
  ServiceType.ServiceType_Order_IOS_Segmentation_Analysis,
  ServiceType.ServiceType_Order_Transcriptor,
  ServiceType.ServiceType_Enable_Transcriptor,
  // WA-6209: uploads are no longer metered; Upload_CBCT/STL counters are gone.
  // Dental-photo upload survives as the enabler.
  ServiceType.ServiceType_Enable_UploadDentalPhoto,
] as const;
